import type { TypedCreditBalance } from '@/lib/credits-api'
import { formatCredits } from '@/lib/subscriptions'

export function formatWeeklySubscriptionCredits(balance: TypedCreditBalance): string {
  return balance.has_unlimited_subscription
    ? 'Unbegrenzt'
    : formatCredits(balance.available_subscription_credits ?? 0)
}

export function hasWeeklySubscriptionCredits(balance: TypedCreditBalance): boolean {
  return Boolean(balance.has_subscription_allowance) || balance.has_unlimited_subscription || (balance.available_subscription_credits ?? 0) > 0
}

export function getTotalBalanceCredits(balances: TypedCreditBalance[] | undefined): number {
  return (balances ?? []).reduce((sum, balance) => sum + Number(balance.available_balance_credits ?? 0), 0)
}
